import React, { useContext } from "react";

export interface FormFieldPrefixProps {
  prefix: string;
}

const FormFieldPrefixContext = React.createContext<FormFieldPrefixProps>({
  prefix: "",
});

export const FormFieldPrefix: React.FC<
  React.PropsWithChildren<FormFieldPrefixProps>
> = ({ children, prefix }) => {
  const parentPrefix = useFormFieldPrefix();
  return (
    <FormFieldPrefixContext.Provider
      value={{
        prefix: [parentPrefix, prefix].filter(Boolean).join("."),
      }}
    >
      {children}
    </FormFieldPrefixContext.Provider>
  );
};

export const useFormFieldPrefix = () => {
  const context = useContext(FormFieldPrefixContext) as
    | FormFieldPrefixProps
    | undefined;
  return context?.prefix ?? "";
};

export const usePrefixedFieldName = (name: string) =>
  [useFormFieldPrefix(), name].filter(Boolean).join(".");
